export default {
	properties: [
		{
			text: 'Nombre',
			key: 'name',
			type: 'text',
			value: '',
			is_title: true,
		},
	],
	singular_model_name_spanish: 'Estado de pedido a Proveedor',
	plural_model_name_spanish: 'Estados de pedido a Proveedor',
	create_model_name_spanish: 'Nuevo',
	text_delete: 'el',
}